import { z } from "zod";

export enum EventType {
  FREE = "FREE",
  PAID = "PAID",
}

export enum EventTimes {
  ONE_TIME = "ONETIME",
  REPEATING = "REPEATING",
}

export enum WeekdayEnum {
  MO = "MO",
  TU = "TU",
  WE = "WE",
  TH = "TH",
  FR = "FR",
  SA = "SA",
  SU = "SU",
}

export enum EventFrequency {
  DAILY = "DAILY",
  WEEKLY = "WEEKLY",
  MONTHLY = "MONTHLY",
  YEARLY = "YEARLY",
}

export enum EventTimeFrame {
  UPCOMING = "upcoming",
  ONGOING = "ongoing",
  PAST = "past",
}

export type EventDto = {
  name: string;
  start_date: Date;
  type: EventType;
  time_type: EventTimes;
  description?: string;
  end_date?: Date;
  repeat?: {
    frequency: EventFrequency;
    interval: number;
    byDay?: WeekdayEnum[];
    byMonthDay?: number[];
    count?: number;
    until?: Date;
  };
  price?: number;
  _id?: string;
  createdAt?: string;
  updatedAt?: string;
  duration: number;
  avatar_image?: string;
  banner_image?: string;
  tags?: string[];
};
